import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import vSelect from 'vue-select'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
import store from './store'
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import {ModelListSelect}  from 'vue-search-select'
import barcode from 'tui-vue-barcode'
import Modal from './modal_plugins.js'
import shopModal from './shop_plugins.js'
import supplierModal from './supplier_modal_plugins.js'
import customerModal from './customer_modal_plugins.js'
// import {default_baseurl} from './setting.js'
const config = require('./config.json')
import Spinner from './spinner.vue';
const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}
Vue.component('Spinner', Spinner)
Vue.use(Snotify, options)
Vue.use(Modal)
Vue.use(shopModal)
Vue.use(supplierModal)
Vue.use(customerModal)
 // axios.defaults.baseURL = 'http://13.126.67.76:3000';
// axios.defaults.baseURL = 'http://localhost:3000';
// axios.defaults.baseURL = 'http://i2oc.com';
axios.defaults.baseURL = config.baseUrl;
Vue.prototype.baseURL2 = axios.defaults.baseURL;
Vue.prototype.$http = axios;
Vue.component('barcode', barcode)
Vue.use(VueGoodTable);
Vue.component('model-list-select',ModelListSelect);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDnvL5EInN-OPUgNbrArsNI3XYys8xYoOI',
    libraries: 'places',
  },
});
Vue.component('v-select', vSelect)
Vue.use(BootstrapVue)
var VueResource = require('vue-resource');
Vue.use(VueResource);


router.beforeEach((to, from, next) => {
  var _this=this;
  if(to.matched.some(record => record.meta.requiresAuth) && (!store.state.userStore.authUser || store.state.userStore.authUser === 'null')){
    next({ path: '/' })
  }else{    
    console.log('abcd')
    console.log(store.state.userStore.authUser)             
    axios.defaults.headers.common['authorization'] = store.state.userStore.authUser 
    next();
  }
});

if (window.localStorage) {
  var localUserString = localStorage.getItem('authUser') || 'null'
  if (localUserString && store.state.userStore.authUser !== localUserString) {
    console.log('if condition')
    store.commit('SET_AUTH_USER', localUserString)
  }
}

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})


// WEBPACK FOOTER //
// ./src/main.js